import FieldConfig from "../../../proto/field-config"
import FieldProgress from "../../../generic/progress/progress"
import Task from "../../../../model2/task/task"
import ItemModelV2 from "../../../../model2/item2/item-model"

export default class FieldTaskProgress extends FieldProgress {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel              = "Progress"
        this.label                  = _.get(config, 'label', 'Progress')
        this.icon                   = 'i5-progress'

        this.hasCalculatedValues    = true

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    canEdit(model:Task):boolean {
        return model.acl.canChangeTaskProgress
    }

    // Custom Methods

    tableCellOnValueChange = async (item: ItemModelV2, value: number | null) => {

        item.task.progress = !_.isNull(value) ? value : null

        item.task.save()
    }
}
